module.exports = __webpack_public_path__ + "c8c2b969902977036133dbb816d7484b.pdf";